import React from "react";
import ExcelJS from "exceljs";

const ExcelExpressReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data)) {
            console.error("Data is not an array:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Define columns with headers
        worksheet.columns = [
            { header: 'S.No', key: 'serial', width: 10 },
            { header: 'Date', key: 'date', width: 20 },
            { header: 'Initiated By', key: 'initiated_by', width: 30 },
            { header: 'File No', key: 'file_no', width: 20 },
            { header: 'Bank Name', key: 'bank_name', width: 50 },
            { header: 'Bank Branch Name', key: 'bank_branch_name', width: 30 },
            { header: 'LH Branch Name', key: 'lh_branch_name', width: 30 },
            { header: 'Express Type', key: 'express_type', width: 20 },
            { header: 'Express Option', key: 'express_option', width: 20 },
            { header: 'Assign Status', key: 'assign_status', width: 20 },
            { header: 'Assign To', key: 'assign_to', width: 30 },
            { header: 'Assign From', key: 'assign_from', width: 30 },
            { header: 'Initiated File Status', key: 'initiated_file_status', width: 30 },
            { header: 'Express Reason', key: 'express_reason', width: 30 },
        ];

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 14 };
        });

        const flattenedData = data.map((report, index) => {
            return {
                serial: report.serial,
                date: report.date ? report.date : "-",
                initiated_by: report.initiated_by ? report.initiated_by : "-",
                file_no: report.file_no ? report.file_no : "-",
                bank_name: report.bank_name ? report.bank_name : "-",
                bank_branch_name: report.bank_branch_name ? report.bank_branch_name : "-",
                lh_branch_name: report.lh_branch_name ? report.lh_branch_name : "-",
                express_type: report.express_type ? report.express_type : "-",
                express_option: report.express_option ? report.express_option : "-",
                assign_status: report.assign_status ? report.assign_status : "-",
                assign_to: report.assign_to ? report.assign_to : "-",
                assign_from: report.assign_from ? report.assign_from : "-",
                initiated_file_status: report.initiated_file_status ? report.initiated_file_status : "-",
                express_reason: report.express_reason ? report.express_reason : "-",
            };
        });

        // Add data rows with custom cell alignment and wrap text
        flattenedData.forEach((item) => {
            const row = worksheet.addRow(item);
            row.eachCell((cell, colNumber) => {
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                if ([1].includes(colNumber)) {
                    cell.numFmt = '0'; // Integer format
                } else if ([5].includes(colNumber)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                } else if ([2].includes(colNumber)) {
                    cell.numFmt = 'dd-mm-yyyy hh:mm:ss'; // For date & time format
                }
            });
        });
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Express Report ${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <button className="excel-download-btn" onClick={exportExcelFile}>
                Download as Excel
            </button>
        </>
    );
};

export default ExcelExpressReport;
